import React from 'react';
import classNames from 'classnames';
import AddRemoveButton from '../../addRemoveButton/components/AddRemoveButton';
var CollectionFieldRow = function (_a) {
    var onButtonClick = _a.onButtonClick, add = _a.add, _b = _a.disabled, disabled = _b === void 0 ? false : _b, buttonDisabled = _a.buttonDisabled, children = _a.children;
    return (React.createElement("div", { className: classNames('collectionField__row', { disabled: disabled }) },
        children ?
            React.createElement("div", { className: 'collectionField__rowItem' }, children)
            : null,
        !disabled && React.createElement("div", { className: 'collectionField__rowButton' },
            React.createElement(AddRemoveButton, { onClick: onButtonClick, add: add, disabled: !!buttonDisabled }))));
};
export default CollectionFieldRow;
//# sourceMappingURL=CollectionFieldRow.js.map